<template>
  <van-button
    plain
    native-type="button"
    size="small"
    :disabled="disabled"
    @click="onSend"
  >
    {{ value }}
  </van-button>
</template>

<script>
import { Toast } from "vant";
import jzValidator from "@jz/validator";

import ATTR_DATA from "@/constants/ATTR_DATA";
import FORM_DATA from "@/constants/FORM_DATA";
import { sendCodeC } from "@/http/serve";
import { beforeLoginSends, sendCodeU } from "@/http/user";
export default {
  name: "TheSendCode",
  props: {
    loginCode: String,
    cacheId: String,
    phone: String,
    type: { type: Number, required: true },
    moduleType: Boolean,
    hasSendCaptcha: { type: Boolean, default: false }
  },
  data() {
    return {
      label: ATTR_DATA.iconPhoneCode, //label 验证码
      value: "获取" + ATTR_DATA.iconPhoneCode, //placeholder
      countdown: 0, // 倒计时状态
      timer: null, //倒计时
      validationList: [99, 0, 18], //短信滑块验证的列表
      validator: null, // 极致验证
      debounceTimer: null, // 防抖
      captchaResult: null // 验证结果
    };
  },
  computed: {
    //禁止发送
    disabled() {
      if (this.countdown === 0) {
        // 需要输入电话号码  0-手机注册 99-手机登录 1-绑定手机 18-申诉提交
        let typeList = [0, 99, 1, 18];

        if (typeList.includes(this.type)) {
          return !(
            this.phone && FORM_DATA.iconPhone.rules.regex.test(this.phone)
          );
        } else {
          return false;
        }
      } else {
        return true;
      }
    }
  },
  mounted() {
    if (this.hasSendCaptcha) {
      jzValidator(
        captchaObj => {
          // 验证成功回调
          captchaObj.success(() => {
            if (this.validator.type !== "aliyun2.0") {
              this.debouncePack(() => {
                this.sendMsg(this.validator.getValidate());
              });
            } else {
              this.handleCaptchaResult();
            }
          });

          // 关闭验证回调
          captchaObj.close(() => {
            this.countdown = 0;
          });

          this.validator = captchaObj;
        },
        {
          scene: "sms",
          captchaVerifyCallback: async captchaVerifyParam => {
            const { rcode, data } = await new Promise(resolve => {
              this.sendMsg({ captchaVerifyParam }, resolve);
            });
            return {
              captchaResult: rcode !== 2100 ? true : false,
              bizResult: rcode === 0 || (data && !!data.limit)
            };
          }
        }
      );
    }
  },
  watch: {
    phone: {
      handler: function(val) {
        if (val && (this.countdown > 0 || this.countdown == "limit")) {
          this.countdown = 0;
        }
      }
    }
  },
  methods: {
    debouncePack(fn) {
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
        this.debounceTimer = null;
      }
      this.debounceTimer = setTimeout(() => {
        fn();
        clearTimeout(this.debounceTimer);
        this.debounceTimer = null;
      }, 300);
    },
    clearNum() {
      this.countdown = 0;
      if (this.timer) clearInterval(this.timer);
    },
    /**
     * @description 发送信息 后期会整合成同一个发送验证码接口
     */
    async sendMsg(captchaParams = {}, callback) {
      // sendCodeC  客服中心 type 15, 16,  6, 18 ,23 ,30, 4
      // 15 锁定
      // 16 解除锁定
      // 6 消除密码锁
      // 18 账号申诉
      // 23 账号注销
      // sendCodeU 账号中心 type 1 4
      // 1 绑定手机
      // 4 手机校验
      // beforeLoginSends 未登陆调用 type 0 99 4
      // 0  手机注册
      // 99 手机登录
      // 4  找回密码

      let api = "";
      //判断类型
      let typeList = [15, 16, 6, 18, 30, 23];
      //sendCodeC sendCodeU 页面模块
      if (this.moduleType) {
        let parmas = this.phone
          ? { type: this.type, phone: this.phone }
          : { type: this.type };
        //账号申诉传递cacheId
        if (this.type === 18) {
          parmas = {
            ...parmas,
            cache_id: this.$ls.get("cacheId"),
            ...captchaParams
          };
        }
        // 注销传递 login_code
        if (this.type === 23) {
          parmas.login_code = this.loginCode;
        }

        typeList.includes(this.type)
          ? (api = sendCodeC(parmas))
          : (api = sendCodeU(parmas));
      } else {
        //beforeLoginSends 模块
        let parmas = this.phone
          ? {
              type: this.type,
              phone: this.phone
            }
          : {
              type: this.type,
              s_login_code: this.$ls.get("loginCode")
            };
        //  0 99 4 滑块验证
        if (
          (this.type === 0 || this.type === 99 || this.type === 4) &&
          this.validator
        ) {
          parmas = {
            ...parmas,
            ...captchaParams
          };
        }
        api = beforeLoginSends(parmas);
      }

      this.captchaResult = await api;
      if (!this.hasSendCaptcha || this.validator.type !== "aliyun2.0") {
        this.handleCaptchaResult();
      } else if (callback) {
        callback(this.captchaResult);
      }
    },
    // 新增验证码结果处理方法
    handleCaptchaResult() {
      const { rcode, rdesc, data } = this.captchaResult;
      // 验证码获取间隔较短/成功场景
      if (rcode == 0 || rcode == 2105) {
        this.$Toast(rdesc);
        this.countdown = data.limit + 1;
        this.autoplay();
      }
      // 验证码上限/超时场景
      else if (rcode == 2107 || rcode == 6002) {
        this.countdown = "limit";
      }
    },
    /**
     * @description 验证码判断
     */
    onSend() {
      if (this.hasSendCaptcha) {
        this.countdown = -1;
        if (this.validator) {
          this.validator.verify();
        } else {
          Toast("网络异常，刷新后重试");
        }
      } else {
        this.sendMsg();
      }
    },
    /**
     * @description 发送倒计时
     */
    autoplay() {
      if (!this.timer) {
        this.timer = setInterval(() => {
          if (this.countdown > 0) {
            this.countdown--;
            if (this.countdown == 0) {
              this.value = "获取" + this.label;
            } else {
              this.value = `${this.countdown}秒后重新获取`;
            }
          } else {
            clearInterval(this.timer);
            this.value = "获取" + this.label;
            this.timer = null;
          }
        }, 1000);
      }
    }
  },
  beforeDestroy() {
    this.clearNum();
  }
};
</script>
<style lang="less" scoped>
.van-button--small {
  height: 0.47rem;
  padding: 0 1em;
  background-color: #ffffff;
  border: solid 1px #48d5af;
  font-size: 0.26rem;
  color: #48d5af;
}
</style>
